import * as React from 'react'
import Menu from '@mui/material/Menu'
import { Checkbox, Typography } from '@mui/material'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { Box } from '@mui/system'
import useStyles from '../useStyles'

export default function MenuFilterTypeOrganization ({
  types,
  handleFilterOrgs
}) {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const getLengthTypesChecked = () => {
    const result = types.filter((type) => type.value).length
    return result > 0 ? '(' + result.toString() + ')' : null
  }

  return (
    <>
      <Box className={classes.boxMenuFilter} onClick={handleClick}>
        <Typography className={classes.buttonSearchInput}>
          Tipo {getLengthTypesChecked()}
        </Typography>
        <ArrowDropDownIcon />
      </Box>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <FiltersList types={types} handleFilterOrgs={handleFilterOrgs} />
      </Menu>
    </>
  )
}

function FiltersList ({ types, handleFilterOrgs }) {
  const classes = useStyles()

  const handleChangeTypeUser = (code) => {
    handleFilterOrgs(code)
  }

  return types && types.length > 0
    ? (
    <Box style={{ width: 220, height: types.length * 37 }}>
      {types.map((type) => (
        <Box key={type.name} className={classes.boxFormControl}>
          <Checkbox
            sx={{
              color: '#026873',
              '&.Mui-checked': {
                color: '#03A696'
              },
              '& .MuiSvgIcon-root': { fontSize: '1.25em' }
            }}
            checked={type.value}
            onChange={() => handleChangeTypeUser(type.name)}
          />
          <Typography sx={{ fontSize: '0.94em', letterSpacing: 0.2 }}>
            {type.name}
          </Typography>
        </Box>
      ))}
    </Box>
      )
    : (
    <Box className={classes.typographyBox}>
      <Typography>No se encontraron tipos de organizaci&oacute;n</Typography>
    </Box>
      )
}
